// FlowMetricToggle — the Notional · Premium · Trades segmented control, built
// off the shared METRIC_ORDER so every metric-switch surface offers the same
// three options in the same order (client-feedback IM-1940). Controlled: the
// caller owns the active-metric state. Styling matches the flow measure toggles
// (breakdown/ranked measure pattern) — role="tab"/aria-selected for a11y +
// testability. (The ranked/breakdown copies of this button are candidates to
// migrate onto this component in a later craft pass — not in scope here.)

import { Box, Stack } from '@mui/material';

import { tokens } from '../../../../styles/tokens';
import {
  FlowMetric,
  METRIC_LABELS,
  METRIC_ORDER,
} from '../../../../providers/options-flow/options-flow.helpers';

interface FlowMetricToggleProps {
  active: FlowMetric;
  onSelect: (metric: FlowMetric) => void;
}

export const FlowMetricToggle = ({ active, onSelect }: FlowMetricToggleProps) => (
  <Stack direction="row" spacing={0.75} role="tablist" sx={{ flexWrap: 'wrap' }}>
    {METRIC_ORDER.map((m) => {
      const isActive = m === active;
      return (
        <Box
          key={m}
          role="tab"
          aria-selected={isActive}
          onClick={() => onSelect(m)}
          sx={{
            cursor: 'pointer',
            fontSize: 9.5,
            fontWeight: 700,
            letterSpacing: '0.3px',
            px: '9px',
            py: '3px',
            borderRadius: '5px',
            color: isActive ? tokens.flow.accent : tokens.text.muted,
            backgroundColor: isActive ? tokens.bg.widget : 'transparent',
            border: `1px solid ${isActive ? tokens.flow.accent : tokens.border.default}`,
            '&:hover': { backgroundColor: tokens.bg.widget },
          }}
        >
          {METRIC_LABELS[m]}
        </Box>
      );
    })}
  </Stack>
);
